import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import DEVICES from '../../common/styles/devices';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

interface ModalContainerProps {
  width: number;
  mobileWidth: number;
}

export const ModalContainer = styled.div<ModalContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${(props: any) => props.width}px;
  background: ${COLORS.white};
  box-shadow: 0px -10px 24px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-family: ${FONT_FAMILY.hellix.regular};

  .error-image {
    float: unset;
  }
  .center {
    text-align: center;
    padding: 32px 16px;
  }
  .btn-wrapper {
    margin-top: 24px;
  }
  @media (${DEVICES.mobileXL}) {
    width: ${(props: any) => props.mobileWidth}px !important;
  }

  @media (${DEVICES.mobileM}) {
    width: 95% !important;
  }
`;

export const CloseModalIcon = styled.img`
  display: initial;
  width: 14px;
  align-self: end;
  justify-self: end;
  float: right;
  margin: 22px 22px 0 0;
  cursor: pointer;
`;

interface ModalBodyContainerProps {
  padding?: [number, number, number, number];
}
export const ModalBodyContainer = styled.div<ModalBodyContainerProps>`
  width: 100%;
  padding: ${({ padding }) =>
    padding ? padding.map((p) => `${p}px`).join(' ') : '5px 24px 60px 24px'};
`;

export const ModalHeader = styled.div`
  font-family: inherit;
  color: ${COLORS.black};
  text-align: center;
  font-size: 18px;
  line-height: 26px;
  font-family: ${FONT_FAMILY.hellix.bold};
`;
export const ModalSubtitle = styled.div`
  font-size: 16px;
  line-height: 22px;
  font-family: ${FONT_FAMILY.hellix.regular};
  text-align: center;
  margin: 12px 0 32px;
`;
export const ModalSubHeader = styled.div`
  margin: 12px 0 27px;
  text-align: center;

  .subHeader {
    color: ${COLORS.textGrey};
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;

    .infoIcon {
      width: 22px;
      height: 22px;
      float: none;
      margin-left: 5px;
      margin-bottom: -5px;
      cursor: pointer;
    }
  }

  .dateContainer {
    display: inline-block;
    color: ${COLORS.black};
    font-size: 14px;
    line-height: 26px;
    font-weight: 700;
    padding: 3px 6px;
    margin-top: 8px;
    border-radius: 2px;
    background-color: rgba(117, 46, 255, 0.1);
    border: 1px solid rgba(117, 46, 255, 0.2);
  }
`;

export const StatusContainer = styled.div`
  background-color: ${COLORS.lightShadedGrey};
  border: 1px solid ${COLORS.borderGrey};
  padding: 16px 16px 0 0;
  border-radius: 4px;
  .deeplink-container {
    padding: 16px;
  }
`;

export const StatusItem = styled.div`
  display: flex;

  .leftDiv {
    width: 14%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .activeImg {
      width: 25px;
      height: 25px;
    }
    .disabledImg {
      width: 25px;
      height: 25px;
      background-color: ${COLORS.white};
    }
    .solidVerticalLine {
      flex-grow: 1;
    }
    .verticalStrokedLine {
      margin: 4px 0;
      width: 25px;
      height: 16px;
    }
  }
  .rightDiv {
    width: 86%;

    .itemHeading {
      display: flex;
      overflow: hidden;

      @media (${DEVICES.mobileXL}) {
        flex-direction: column; /* Stack items vertically on mobile */
        align-items: flex-start; /* Align items to the start */
      }

      .firstColumn {
        width: 65%;
        float: left;
        line-height: 26px;
        font-family: ${FONT_FAMILY.hellix.bold};
        white-space: nowrap;
        text-overflow: ellipsis;
        @media (${DEVICES.mobileXL}) {
          width: 100%;
        }
      }
      .secondColumn {
        display: block;
        margin-left: 5px;
        width: 35%;
        text-align: right;
        font-size: 11px;
        line-height: 28px;
        font-family: ${FONT_FAMILY.hellix.bold};
        color: ${COLORS.textGrey};
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        @media (${DEVICES.mobileXL}) {
          width: 100%;
          margin-left: 0; /* Remove left margin */
          text-align: left; /* Align to left on mobile */
        }
      }
      .width-100 {
        width: 100%;
      }

      .firstColumn.withOverflow {
        overflow: hidden;
      }
      .activeHeading {
        font-size: 16px;
        color: ${COLORS.black};
      }
      .disabledHeading {
        font-size: 16px;
        color: ${COLORS.textLightGrey};
      }
    }
    .itemDescription {
      font-size: 16px;
      line-height: 22px;
      font-weight: 400;
      color: ${COLORS.textLightGrey};

      .rfiError {
        color: ${COLORS.red};
      }
      .seeDetails {
        font-weight: 700;
        color: ${COLORS.darkBlue};
      }
    }

    .emptySpace {
      height: 16px;
    }
  }
`;

export const MessageBox = styled.div<{ error?: boolean }>`
  width: 98%;
  margin-bottom: 32px;
  border: ${({ error }) =>
    error ? `1px solid rgba(254, 0, 149, 0.40)` : `1px solid rgba(72, 250, 255, 0.4)`};
  background: ${({ error }) => (error ? `rgba(254, 0, 149, 0.10)` : `rgba(72, 250, 255, 0.1)`)};
  padding: 12px 16px;
  font-size: 14px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  grid-column: 1/5;
  .text {
    font-size: 14px;
    line-height: 22px;
    font-family: ${FONT_FAMILY.hellix.regular};
    margin-left: 12px;
  }
  @media ${DEVICES.tab} {
    width: 100%;
    align-items: flex-start;
    grid-column: 1/3;
  }
  @media ${DEVICES.mobileL} {
    align-items: flex-start;
  }
`;

export const PaymentInfoContainer = styled.div`
  background-color: ${COLORS.lightShadedGrey};
  border: 1px solid ${COLORS.borderGrey};
  margin: 0 20px 24px 0;
  display: flex;
  padding: 24px 16px;
  border-radius: 8px;
  display: flex;
  grid-column: 1/5;

  font-size: 16px;
  line-height: 26px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.textGrey};

  img {
    width: 24px;
    height: 24px;
    margin-right: 12px;
  }
`;

export const VideoVerificationContainer = styled.div`
  background-color: ${COLORS.lightShadedGrey};
  border: 1px solid ${COLORS.borderGrey};
  margin: 0 20px 24px 0;
  display: flex;
  padding: 24px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  grid-column: 1/5;
  .firstColumn {
    width: 70%;
    .headerItem {
      font-size: 16px;
      line-height: 26px;
      font-family: ${FONT_FAMILY.hellix.bold};
      color: ${COLORS.textGrey};
    }
    .subHeader {
      font-size: 14px;
      line-height: 18px;
      font-family: ${FONT_FAMILY.hellix.regular};
      font-weight: 400;
    }
  }
  .secondColumn {
    width: 30%;
    display: flex;
    justify-content: right;
  }

  @media screen and (max-width: 790px) {
    flex-direction: column;
    margin: 0;
    .firstColumn {
      width: unset;
    }
    .secondColumn {
      width: unset;
      margin-top: 22px;
      justify-content: center;
    }
  }
  @media (${DEVICES.mobileM}) {
    margin: 0;
    button {
      height: 60px;
    }
  }
`;
export const PaidText = styled.div`
  font-size: 14px;
  font-family: ${FONT_FAMILY.hellix.bold};
  line-height: 18px;
  color: ${COLORS.textGrey};
`;

type HelpSectionContainerProps = {
  width?: string;
  height?: string;
};

export const HelpSectionContainer = styled.div<HelpSectionContainerProps>`
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.width ? `${props.width}%` : '351px')};
  height: ${(props) => (props.height ? `${props.height}px` : 'auto')};
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 10px;
  background-color: ${COLORS.white};
  padding: 24px;
  .closeIcon {
    align-self: end;
    float: right;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  .heading-bold {
    color: ${COLORS.black};
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    padding-bottom: ${(props) => (props.width === '100%' ? '24px' : '0')};
  }
  .heading {
    color: ${COLORS.textGrey};
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    padding-bottom: ${(props) => (props.width === '100%' ? '32px' : '0')};
  }
  .btn-wrapper {
    margin: 24px 0px;
  }
  .logo {
    text-align: center;
    padding-bottom: ${(props) => (props.width === '100%' ? '8px' : '0')};
  }
`;
